import constClass from '../../Constants/Constants';
import Common from '../Common/common';
//import moment from 'moment';
import React from 'react';

const TicketList = ({ ticket_list, ticketClick, siteId, setting }) => {

  // const sysdate = new Date();
  // const sysdateTimestamp = sysdate.getTime();

  return (
    <div id="ticketList" className="ticket-list">
      {ticket_list && ticket_list.map(ticket =>
        <div key={ticket.ticket_id} className="ticket-box">
          <div className="frame39">
            <div className="ticket-name">{ticket.ticket_name}</div>
            {/* {ticket.ticket_summary && <div className="ticket-summary">{ticket.ticket_summary}</div>} */}
          </div>
          <div className="frame42">
            {ticket.ticket_image_url && <img className="ticket-image" src={`/${siteId}/${constClass.TICKET_IMAGE_DIR}${ticket.ticket_image_url}`} alt={ticket.ticket_name} style={{ objectFit: 'cover' }}/>}
            {!ticket.ticket_image_url && <img className="ticket-image" src={`/${siteId}/noimage.png`} alt="noimage" />}
            <div className='frame41'>
              <div className="ticket-detail">{Common.getBrString(ticket.ticket_summary)}</div>
              <button
                onClick={() => ticketClick(ticket.ticket_id)}
                className="button text-black bg-lightwhite">
                クーポンを表示する
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default TicketList;